export function IsKDTreeSplitter(splitter) {
    return splitter.splitAxisSelector !== undefined;
}
export function RoundRobin(depth, dimension) {
    return depth % dimension;
}
//# sourceMappingURL=tree.spatial.interfaces.js.map